require('./goal-settings.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/number/number-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/location-tracking/location-tracking-module')
require('../components/animate/animate-module')
require('../components/error-handler/error-handler-module')
require('../components/payment/payment-module')
require('../components/analyze-access/analyze-access-module')

# Load Css
require('../../../sass/web/html/_goal_setting.scss')

GoalSettingsCtrl = require('./goal-settings-controller')
GoalSettingsService = require('./goal-settings-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-form'
  'gnp-location-tracking'
  'gnp-animate'
  'gnp-error-handler'
  'gnp-number'
  'gnp-payment'
  'gnp-analyze-access'
]
angular.module 'gnp-app-goal-settings', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/goal-settings',
      templateUrl: 'web/goal-settings/goal-settings.jade'
      controller: 'GoalSettingsCtrl'
      title: '_GOAL_SETTINGS.TITLE'
      permission:
        signInRequired: true
        paymentRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'GoalSettingsCtrl', GoalSettingsCtrl
  .factory 'GoalSettingsService', GoalSettingsService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/goal-settings/goal-settings-module.coffee